import { render, staticRenderFns } from "./AccountSystemRestart.vue?vue&type=template&id=4b3aecd7&scoped=true&"
import script from "./AccountSystemRestart.vue?vue&type=script&lang=js&"
export * from "./AccountSystemRestart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3aecd7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ccsbetaccscom/web/live/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b3aecd7')) {
      api.createRecord('4b3aecd7', component.options)
    } else {
      api.reload('4b3aecd7', component.options)
    }
    module.hot.accept("./AccountSystemRestart.vue?vue&type=template&id=4b3aecd7&scoped=true&", function () {
      api.rerender('4b3aecd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/AccountSystemRestart.vue"
export default component.exports